import ls from 'localstorage-slim';

export const OVERRIDES_STORAGE_KEY = '__DATABASES_FF_OVERRIDES';

const flagsStorageInstance = ls;

type FeatureFlagOverrides = { [key: string]: boolean };

/**
 * Determine whether there are any persisted FF overrides
 */
export const hasOverrides = (): boolean =>
  flagsStorageInstance.get(OVERRIDES_STORAGE_KEY) !== null;

/**
 * Get persisted overrides from the storage.
 */
export const getOverrides = (): FeatureFlagOverrides => {
  if (!hasOverrides()) {
    return {} as FeatureFlagOverrides;
  }

  return flagsStorageInstance.get(OVERRIDES_STORAGE_KEY) ?? ({} as FeatureFlagOverrides);
};

export const addOverrides = (newOverrides: FeatureFlagOverrides): void => {
  const overrides = getOverrides();

  for (const flagKey in newOverrides) {
    overrides[flagKey] = newOverrides[flagKey];
  }

  flagsStorageInstance.set(OVERRIDES_STORAGE_KEY, overrides);
};

export const removeOverrides = (overridesToRemove: string[]): void => {
  const overrides = getOverrides();

  for (const flagKey in overridesToRemove) {
    delete overrides[overridesToRemove[flagKey]];
  }

  flagsStorageInstance.set(OVERRIDES_STORAGE_KEY, overrides);
};

export const clearOverrides = (): void => {
  flagsStorageInstance.remove(OVERRIDES_STORAGE_KEY);
};
